import { format, isValid, parse } from 'date-fns';
import { get } from 'lodash';

export const encodeDateFilter = (fromFormat, toFormat) => (filters, name) => {
  const filter = get(filters, name);

  const parsedFilter = parse(filter, fromFormat, new Date());

  if (!isValid(parsedFilter)) return undefined;

  return {
    operator: 'eq',
    values: [format(parsedFilter, toFormat)],
    type: 'date',
    key: name,
  };
};

export const decodeDateFilter = (fromFormat, toFormat) => ({
  values,
  key,
}) => ({
  [key]: format(parse(values[0], fromFormat, new Date()), toFormat),
});
